export enum RichTextEditorNodes {
  List = 'List',
  Typography = 'Typography',
}
